import { View } from 'react-native'
import Typography from '@ui/typography'
import cn from '@ui/utils/cn'

interface Props {
  text: string
  className?: string
}

export default function InputTextEnd({ text, className }: Props) {
  return (
    <View
      className={cn(
        'flex h-full max-w-[40%] shrink items-end justify-center pr-4',
        className
      )}
      style={{ maxWidth: '40%' }}
    >
      <Typography
        variant="SM"
        numberOfLines={1}
        ellipsizeMode="tail"
        className="font-text-semibold color-black/25"
      >
        {text}
      </Typography>
    </View>
  )
}
